import { observer } from 'mobx-react-lite'
import { CollapseWithIcon } from 'shared/ui'
import { IntegrationSettingsWebhook } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/IntegrationSettingsWebhook/IntegrationSettingsWebhook'
import type { IntegrationWebhookStore } from 'pages/settings/pages/integrations/store/IntegrationWebhookStore'
import type { IntegrationCollapseSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationCollapseSettingsStore'

import sharedStyles from 'pages/settings/pages/integrations/pages/integrationSettings/ui/styles.module.scss'

type ICollapseIntegrationSettingsWebhookProps = {
  collapseStore: IntegrationCollapseSettingsStore
  webhookStore: IntegrationWebhookStore
  withLeadOwner?: boolean
}

export const CollapseIntegrationSettingsWebhook = observer(
  ({
    collapseStore,
    webhookStore,
    withLeadOwner = false,
  }: ICollapseIntegrationSettingsWebhookProps) => {
    return (
      <CollapseWithIcon
        opened={collapseStore.opened('webhook')}
        onClick={collapseStore.onToggle('webhook')}
        icon={'webhookOutline'}
        title={'Webhook'}
        label={`Send ${webhookStore.integrationName} contacts into your Salesmsg account`}
        headerClassName={sharedStyles.collapseWithIcon}
      >
        <IntegrationSettingsWebhook store={webhookStore} withLeadOwner={withLeadOwner} />
      </CollapseWithIcon>
    )
  }
)
